import ru from 'vee-validate/dist/locale/ru.json';

export default {
  messages: {
    ...ru.messages,
    txHash: "Хеш транзакции не верен",
    IPV4_6: "IP-адрес недействителен",
    required: "Поле обязательно для заполнения",
    confirmed: "Поле не совпадает",
    txAddress: "Недействительный адрес",
  },
  names: {
    email: "электронная почта",
    password: "Пароль",
  },
  fields: {
    password: {
      min: "{_field_} слишком короткий, хотите, чтобы вас взломали?",
    },
  },
};
